import i18n from 'i18n';

export const CLIENT_TYPE_OPTIONS = [
  {
    value: 'individual',
    label: i18n.t('client.individual'),
    icon: 'bx bx-user',
  },
  {
    value: 'legal',
    label: i18n.t('client.legal'),
    icon: 'bx bx-building',
  },
];

export const getFilteredClientTypeOptions = settings => {
  if (!settings) return CLIENT_TYPE_OPTIONS;

  const { enableForIndividual, enableForLegal } = settings;

  return CLIENT_TYPE_OPTIONS.filter(option => {
    if (option.value === 'individual') return enableForIndividual !== false;
    if (option.value === 'legal') return enableForLegal !== false;
    return true;
  });
};
